import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {type DeadlineUserEvent, type UserEvent} from 'yougile-model'

const isDeadlineUserEvent = (event?: UserEvent): event is DeadlineUserEvent => {
  return event?.type === 'deadline'
}

export const getActionNameChangeDeadline = (event: UserEvent): string => {
  if (!isDeadlineUserEvent(event)) {
    return ''
  }

  const {
    oldDeadline,
    oldStartDate,
    oldHasTime,
    newDeadline,
    newStartDate,
    newHasTime
  } = event.options

  if (!oldDeadline && newDeadline === '') {
    return Lang.msg.statsTimeline.statActionAttachedDeadline
  }

  if (!oldDeadline && newDeadline) {
    if (newDeadline && newStartDate) {
      const dateStart = getDate(newStartDate)
      const deadline = getDate(newDeadline)
      const deadlineTime = newHasTime ? getTime(newDeadline, newHasTime) : ''

      return Lang.msg.statsTimeline.statActionSetDeadlineTwo({
        dateStart,
        deadline,
        deadlineTime
      })
    }

    if (newDeadline) {
      const deadline = getDate(newDeadline)
      const deadlineTime = getTime(newDeadline, newHasTime)

      return Lang.msg.statsTimeline.statActionSetDeadlineOne(
        deadline,
        deadlineTime
      )
    }
  }

  if (oldDeadline && newDeadline) {
    const oldDt = {
      dateStart: getDate(oldStartDate),
      deadline: getDate(oldDeadline),
      dateStartTime: getTime(oldStartDate, oldHasTime),
      deadlineTime: getTime(oldDeadline, oldHasTime)
    }

    const newDt = {
      dateStart: getDate(newStartDate),
      deadline: getDate(newDeadline),
      dateStartTime: getTime(newStartDate, newHasTime),
      deadlineTime: getTime(newDeadline, newHasTime)
    }

    return Lang.msg.statsTimeline.statActionChangeDeadlineTwoTime(oldDt, newDt)
  }

  return Lang.msg.statsTimeline.statActionDetachedDeadline
}

const getDate = (date: number | undefined): string => {
  if (!date) {
    return ''
  }
  return Time.formatCustom(date, 'DD.MM.YYYY')
}
const getTime = (
  date: number | undefined,
  hasTime: boolean | undefined
): string => {
  if (!date || !hasTime) {
    return ''
  }
  return Time.formatShort(date, true)
}
